"use strict";
(globalThis["webpackChunktvg_shopify_theme"] = globalThis["webpackChunktvg_shopify_theme"] || []).push([[8569],{

/***/ 5467:
/***/ ((__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) => {

/* harmony import */ var _core_shopify_init_section_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8711);
// @ts-nocheck

(0,_core_shopify_init_section_index_js__WEBPACK_IMPORTED_MODULE_0__.initSection)('.sol-card-carousel__container', (_section)=>{
    const sectionId = $(_section).attr('id');
    $(_section).find('.sol-card-carousel__slider').slick({
        mobileFirst: true,
        variableWidth: false,
        infinite: true,
        dots: true,
        dotsClass: 'dots',
        appendDots: '.slider-nav__dots.' + sectionId,
        arrows: false,
        swipe: true,
        responsive: [
            {
                breakpoint: 575,
                settings: {
                    centerMode: true,
                    focusOnSelect: true,
                    centerPadding: '20%'
                }
            },
            {
                breakpoint: 767,
                settings: {
                    centerMode: true,
                    focusOnSelect: true,
                    centerPadding: '8%'
                }
            },
            {
                breakpoint: 991,
                settings: {
                    centerMode: true,
                    focusOnSelect: true,
                    centerPadding: '15%'
                }
            },
            {
                breakpoint: 1199,
                settings: {
                    centerMode: true,
                    focusOnSelect: true,
                    centerPadding: '25%'
                }
            }
        ]
    });
});


/***/ })

},
/******/ __webpack_require__ => { // webpackRuntimeModules
/******/ var __webpack_exec__ = (moduleId) => (__webpack_require__(__webpack_require__.s = moduleId))
/******/ __webpack_require__.O(0, [2333], () => (__webpack_exec__(5467)));
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ }
]);